<div [hidden]="isLoadingForm">
  <im-sow-sections
    [config]="config"
    [defaultFormId]="defaultFormId"
    [toggleSections]="toggleSections"
    [sowScreens]="sowScreens"
    [creationMode]="!created"
    (toggleChanged)="onSelectedSections($event)"
    (sowFormChanged)="onSowFormChanged($event)"
    (loadingNewForm)="onLoadingNewForm($event)"
    >
  </im-sow-sections>

  <im-sow-form
    [inspectionId]="null"
    [sections]="sections"
    [controls]="controls"
    [formValues]="formValues"
    [isReadOnly]="config?.isReadOnly"
    >
  </im-sow-form>
</div>

@if (isLoadingForm) {
  <mat-spinner diameter="32"></mat-spinner>
}
